import DataCache from './data-cache'

// 全局cache
const rootCache = new DataCache()

export default rootCache
